import React from "react";
import { useTranslation } from "react-i18next";
import SkeletonBlock from "./SkeletonBlock";
import { topItem } from "./kpiHelpers";

// Gemstone Clicks' equivalent of ReportRankedBreakdown — "days ranked by
// clicks" isn't a useful sidebar for this report, so instead this shows the
// most-clicked value per attribute (Shape/Size/Color/Cut/Clarity), derived
// from the same multi-attribute LoadExtendedGemstoneChartReports("ExtGemstoneChrt")
// payload every report already fetches. Matches the prototype's "Top Gemstone
// Attribute Profile" panel; an Avg Price card was left out since no
// aggregate price data is available in this payload (would need a backend
// addition to add honestly).
const ClicksAttributeProfile = ({ report, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="edr-panel mt-4">
        <div className="edr-kpis">
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonBlock className="edr-kpi-skeleton" key={index} />
          ))}
        </div>
      </div>
    );
  }

  const attributes = [
    { lab: t("Shape"), top: topItem(report?.GemstoneShapeSearches, "Cut", "CNT") },
    { lab: t("Size"), top: topItem(report?.GemstoneSizeSearches, "Size", "CNT") },
    { lab: t("Color"), top: topItem(report?.GemstoneColorSearches, "Color", "CNT") },
    { lab: t("Cut"), top: topItem(report?.GemstoneCutGradeSearches, "CutGrade", "CNT") },
    { lab: t("Clarity"), top: topItem(report?.GemstoneClaritySearches, "Clarity", "CNT") },
  ];

  return (
    <div className="edr-panel mt-4">
      <div className="edr-panel-head">
        <div>
          <h3>{t("Top Gemstone Attribute Profile")}</h3>
          <div className="edr-panel-desc">{t("Most-clicked value in each attribute")}</div>
        </div>
      </div>
      <div className="edr-kpis">
        {attributes.map((attr, index) => (
          <div className="edr-kpi" key={index}>
            <div className="edr-kpi-lab">{attr.lab}</div>
            <div className="edr-kpi-val">{attr.top?.label ?? "—"}</div>
            {attr.top && <div className="edr-kpi-sub">{attr.top.percentage}% {t("of searches")}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClicksAttributeProfile;
